import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import './CreditCardNone.css'

const CreditCardNoneUI = ({context, messageList}) =>
  <div className='acc_cc_n'>
    <MessageUI messageList={messageList} messageKey='c_no_card' />
  </div>

export default CreditCardNoneUI
